import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { baseAPI } from '../../../config';
import { toast } from 'react-toastify';
import AnnotationCard from './AnnotationCard';
import userStore from '../../../store/userStore';

const AnnotationsPanel = ({ expedientId, annotations: initialAnnotations, onAnnotationAdded }) => {
  const { user } = userStore();
  const [annotations, setAnnotations] = useState(initialAnnotations || []);
  const [anotacion, setAnotacion] = useState('');
  const [tarea, setTarea] = useState('');
  const [loading, setLoading] = useState(false);
  const [visibleAnnotations, setVisibleAnnotations] = useState(10);

  // Update annotations when initialAnnotations changes
  useEffect(() => {
    if (initialAnnotations) {
      setAnnotations(initialAnnotations);
    }
  }, [initialAnnotations]);

  const loadMoreAnnotations = () => {
    setVisibleAnnotations(prev => prev + 10);
  };

  const handleAddAnnotation = async e => {
    e.preventDefault();

    if (!anotacion.trim()) {
      toast.error('La anotación no puede estar vacía');
      return;
    }

    const infoNote = {
      expedient_id: expedientId,
      anotacion,
      fecha: new Date(),
      user_id: user.id,
      creator_name: user.name,
      creator_role: user.role,
      tarea: tarea || 'No hay tarea',
    };

    try {
      setLoading(true);
      const response = await axios.post(`${baseAPI}/annotations/`, infoNote, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      toast.success('Anotación añadida con éxito');

      // Add the new annotation to the list
      // Backend returns { message, annotation }
      const newAnnotation = response.data.annotation || response.data;
      setAnnotations(prev => [newAnnotation, ...prev]);

      // Notify parent component
      if (onAnnotationAdded) {
        onAnnotationAdded(newAnnotation);
      }

      setAnotacion('');
      setTarea('');
    } catch (error) {
      console.error(error);
      toast.error('Error al añadir la anotación');
    } finally {
      setLoading(false);
    }
  };

  const sortedAnnotations = [...annotations]
    .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
    .slice(0, visibleAnnotations);

  return (
    <div className='p-4'>
      {/* Form to add annotation */}
      <div className='mb-6 p-4 bg-slate-50 rounded-lg border border-slate-200'>
        <h3 className='text-sm font-semibold text-slate-900 mb-3'>Añadir nueva anotación</h3>
        <form onSubmit={handleAddAnnotation}>
          <div className='mb-3'>
            <textarea
              className='w-full p-3 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 text-sm'
              rows='3'
              placeholder='Escribe aquí tu anotación'
              value={anotacion}
              onChange={e => setAnotacion(e.target.value)}
            />
          </div>
          <div className='flex items-center mb-3'>
            <label className='block text-xs font-medium text-gray-700 mr-3'>
              {user.role === 'admin' ? '¿Es una tarea para el cliente?' : '¿Es una tarea para el equipo?'}
            </label>
            <input
              type='checkbox'
              className='h-4 w-4 text-blue-600'
              checked={tarea === 'Pendiente'}
              onChange={() => setTarea(prev => (prev === 'Pendiente' ? '' : 'Pendiente'))}
            />
          </div>
          <button
            type='submit'
            disabled={loading || !anotacion.trim()}
            className={` py-2 px-4 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition text-sm font-medium ${
              loading || !anotacion.trim() ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            {loading ? 'Añadiendo...' : 'Añadir anotación'}
          </button>
        </form>
      </div>

      {/* Annotations list */}
      <div>
        <h3 className='text-base font-semibold text-slate-900 mb-4'>Anotaciones</h3>
        {sortedAnnotations.length === 0 ? (
          <div className='text-center py-12'>
            <p className='text-base text-slate-500'>No hay anotaciones.</p>
          </div>
        ) : (
          <div>
            {sortedAnnotations.map((annotation, index) => (
              <div key={annotation._id}>
                <AnnotationCard annotation={annotation} />
                {index < sortedAnnotations.length - 1 && <div className='h-px bg-gray-200'></div>}
              </div>
            ))}
            {visibleAnnotations < annotations.length && (
              <button
                onClick={loadMoreAnnotations}
                className='mt-4 text-sm text-blue-600 hover:text-blue-700 font-medium w-full text-center py-2'
              >
                Ver más anotaciones...
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AnnotationsPanel;
